export default __webpack_public_path__ + "static/media/feather-folder-plus.85f078f5.svg";